import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";

type PlayerProps = {
  src: string;
  loop?: boolean;
  controls?: boolean;
  keepLastFrame?: boolean;
  className?: string;
  autoplay?: boolean;
  style?: React.CSSProperties;
};

// Dynamically import the Player only on client-side
const LottiePlayer = forwardRef<any, PlayerProps>((props, ref) => {
  const [PlayerComponent, setPlayerComponent] = useState<any>(null);
  const playerRef = useRef<any>(null);

  useEffect(() => {
    // Only import on client-side where document exists
    import("@lottiefiles/react-lottie-player").then((module) => {
      setPlayerComponent(() => module.Player);
    });
  }, []);

  // Expose player methods through the forwarded ref
  useImperativeHandle(ref, () => ({
    play: () => playerRef.current?.play?.(),
    pause: () => playerRef.current?.pause?.(),
    stop: () => playerRef.current?.stop?.(),
    setSeeker: (frame: number) => playerRef.current?.setSeeker?.(frame),
    setPlayerSpeed: (speed: number) =>
      playerRef.current?.setPlayerSpeed?.(speed),
    getLottie: () => playerRef.current?.getLottie?.(),
  }));

  if (!PlayerComponent) {
    // Return placeholder with same dimensions during SSR/loading
    return <div className={props.className} style={props.style} />;
  }

  return <PlayerComponent ref={playerRef} {...props} />;
});

LottiePlayer.displayName = "LottiePlayer";

export default LottiePlayer;
